<template>
    <div>
      <div :class="['file-nav', scenario === 'fileSelect' && 'file-select', $route.name === 'OpenView' && ($route.params.module === 'select_files' || !isOpenIndex) && 'open-selector', show ? 'show' : 'hide']" @scroll="onScroll">
          <div class="sub-nav" v-if="scenario !== 'fileSelect' && $route.name !== 'OpenView'">
            <router-link :to="{ params: { space: 'frequent', id: null } }" replace tag="div" class="nav-item">
              <div class="name">
                <div class="ellipsis">{{ $t('file.frequent') }}</div>
                <i class="iconfont icon-arrow-next"/>
              </div>
            </router-link>
          </div>
          <search-sort
            v-if="isOpenIndex"
            @search-input-click="toggleSearch"
          />
          <div class="nav-user-name" v-if="isOpenIndex && $route.name === 'OpenView' && userName">{{userName}}</div>
          <div class="sub-nav">
            <slot v-if="!is_personal">
              <div v-if="$route.name !== 'OpenView'" class="sub-title">{{ $t('file.myEnterpriseFiles') }}</div>
              <Tree
                v-if="departments"
                :data="departments"
                :load-data="loadDepartment"
                :showArrowNext="true"
                @on-select-change="handleDeptSelect"
                :childrenKey="childrenKey"
              />
            </slot>
            <div class="nav-item" v-if="!is_personal_space_closed" @click="go({ space: 'own', id: null })">
              <space-icon space="own"></space-icon>
              <div class="name">
                <div class="ellipsis">{{ $t('file.personalFiles') }}</div>
                <i class="iconfont icon-arrow-next"/>
              </div>
            </div>
            <div class="nav-item" v-if="!is_personal" @click="go({ space: 'collab', id: null })">
              <space-icon space="collab"></space-icon>
              <div class="name">
                <div class="ellipsis">{{ $t('file.collabWithMe') }}</div>
                <i class="iconfont icon-arrow-next"/>
              </div>
            </div>
          </div>
          <div class="sub-nav" v-if="external_list && $route.name !== 'OpenView'">
            <div class="sub-title">{{ $t('file.externalCollabFiles') }}</div>
            <div class="nav-item" v-for="item of external_list" :key="item.id" @click="go({ space: 'external', id: `${item.type}_${item.id}` })">
              <space-icon :space="item.type"></space-icon>
              <div class="name">
                <div class="ellipsis">{{ item.name }}</div>
                <i class="iconfont icon-arrow-next"/>
              </div>
            </div>
          </div>
          <div class="sub-nav" v-if="scenario !== 'fileSelect' && $route.name !== 'OpenView'">
            <div class="nav-item">
              <div class="name">
                <router-link :to="{ params: { space: 'trash', id: null }}" replace tag="div" class="ellipsis">{{ $t('file.trash') }}</router-link>
                <i class="iconfont icon-arrow-next"/>
              </div>
            </div>
          </div>
      </div>
      <popover-ai-link></popover-ai-link>
   </div>
</template>
<script>
import config from '@/config'
import {i18n} from '@/utils/i18n'
import ajax from '@/utils/ajax'
import Tree from '../utils/Tree'
import SwipeDetect from '@/utils/SwipeDetect'
import SearchSort from './SearchSort'
import { EXTERNAL_ENTERPRISES, FIND_USER_DEPARTMENTS, DEPARTMENT_INFO } from '@/config/api'
import PopoverAiLink from '../popoverAiLink'

let scrolling = false
const DEFAULT_EXPAND_DEPTH = 2

export default {
  name: 'FileNav',
  i18n,
  components: {
    Tree,
    SearchSort,
    PopoverAiLink
  },
  props: {
    show: Boolean,
    scenario: {
      type: String,
      default: 'fileView'
    },
    isOpenIndex: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      is_personal: config.enterprise_info.is_personal_user_enterprise,
      is_personal_space_closed: config.enterprise_info.is_personal_space_closed,
      external_list: null,
      childrenKey: 'children',
      departments: [],
      toBottom: false,
      userName: config.openConfig.userName
    }
  },
  computed: {

  },
  watch: {
    show (val) {
      if (val) {
        scrolling = false
      }
    }
  },
  created () {
    this.getExternalEnterprises()
    if (!this.is_personal) {
      this.findUserDepartments()
    }
  },
  mounted () {
    /* eslint-disable no-new */
    new SwipeDetect({
      element: this.$el,
      threshold: 2,
      allowedTime: 3000,
      handleTouch: (e, direction, phase, swipe, distance) => {
        setTimeout(() => {
          // toast(scrolling)
          if ((!scrolling || this.$el.clientHeight === this.$el.scrollHeight) && swipe !== 'none' && (direction === 'up' || direction === 'down')) {
            console.log('swipe....')
            this.$router.go(-1)
          }
        }, 20)
      }
    })
    /* eslint-enable no-new */
  },
  methods: {
    onScroll (e) {
      scrolling = true
      console.log('scroll......')
      if (this.$el.scrollTop + this.$el.clientHeight >= this.$el.scrollHeight) {
        setTimeout(() => {
          scrolling = false
        }, 100)
      }
    },
    go (params) {
      if (this.scenario === 'fileSelect') {
        this.selectListStack.push(params)
        this.$router.go(-1)
      } else {
        const query = { ...this.$route.query }
        delete query.filenav
        delete query.tab
        this.$router.replace({ params, query })
      }
    },
    getExternalEnterprises (params) {
      ajax({url: EXTERNAL_ENTERPRISES}).then(result => {
        this.external_list = result.external_list
      })
    },
    findUserDepartments (params) {
      let url = FIND_USER_DEPARTMENTS
      if (params && params.department_id) {
        url += `?department_id=${params.department_id}`
      }
      ajax({url, parser: this.parserData}).then(departments => {
        departments && departments.forEach(rootNode => {
          this.expandDefaultTree(rootNode, 1)
        })
        this.departments = departments
      })
    },
    expandDefaultTree (node, depth) {
      let childrenKey = this.childrenKey
      if (node.has_children_departments) {
        if (node[childrenKey] && node[childrenKey].length) {
          // node.expand = expand
          node.expand = depth <= DEFAULT_EXPAND_DEPTH
          depth += 1
          node[childrenKey].forEach(child => this.expandDefaultTree(child, depth))
        } else if (!node[childrenKey]) {
          node.loading = false
          node[childrenKey] = []
        }
      }
      return node
    },
    loadDepartment (item, callback) {
      ajax({
        url: DEPARTMENT_INFO,
        data: {
          department_id: item.id
        },
        parser: this.parserData
      }).then(departments => {
        departments.forEach(rootNode => {
          this.expandDefaultTree(rootNode, 1)
        })
        callback(departments[0].children)
      })
    },
    handleDeptSelect (dept) {
      this.go({space: 'dept', id: dept[0].id})
    },
    parserData (response) {
      const data = response.departments || response.department
      if (data && !(Array.isArray(data) && !data.length)) { // when departments is empty
        return [data]
      }
      return data
    },
    toggleSearch () {
      this.$emit('search-input-click')
    }
  }
}
</script>

<style lang="postcss">
@import 'variables';

.file-nav {
  background: var(--pageBgColor);
  position: absolute;
  top: 44px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  z-index: 1;

  &.open-selector {
    margin-bottom: 50px;
  }

  & .sub-nav {
    margin: 10px 0;
    background: #fff;
    padding-left: 15px;
  }

  & .nav-user-name {
    font-size: 12px;
    color: #747b93;
    margin-left: 15px;
    margin-top: 8px;
  }

  & .sub-title {
    border-bottom: 1px solid var(--sepLineColor);
    color: var(--secondlyTitle);
    font-size: 12px;
    height: 36px;
    line-height: 36px;
  }

  & .nav-item {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;

    & .type-icon {
      flex: 0 0 auto;
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    & .name {
      border-bottom: 1px solid var(--sepLineColor);
      flex: 1 1 auto;
      display: flex;
      overflow: hidden;
      padding-right: 10px;

      & div {
        flex: 1 1 auto;
        overflow: hidden;
      }

      & .icon-arrow-next {
        flex: 0 0 auto;
        color: var(--contentIcon);
      }
    }
  }

  & .nav-item:last-child {
    & .name {
      border: 0;
    }
  }
}
.file-nav.file-select {
  top: 74px
}

.file-nav.hide {
  transform: translate3d(0, -108%, 0);
  transition: .5s ease-in;
}
.file-nav.show {
  transform: translate3d(0, 0, 0);
  transition: .5s ease-out;
}
</style>
